<template>
  <div class="site-header">
    <div class="site-header__row">
      <img class="site-header__logo" referrerpolicy="no-referrer" :src="logoSrc" alt="皓溶生物" />
      <div class="site-header__nav">
        <router-link class="site-header__link site-header__link--home" :class="activeMenu === 'home' ? 'site-header__link--active' : ''" to="/" exact>首页</router-link>
        <router-link class="site-header__link site-header__link--research" :class="activeMenu === 'research' ? 'site-header__link--active' : ''" to="/research">科研实力</router-link>
        <router-link class="site-header__link site-header__link--news" :class="activeMenu === 'news' ? 'site-header__link--active' : ''" to="/news">新闻中心</router-link>
      </div>
      <button class="site-header__search-trigger" :class="searchVisible ? 'site-header__search-trigger--active' : ''" type="button" aria-label="打开搜索" @click="toggleSearch">
        <img class="site-header__icon" referrerpolicy="no-referrer" :src="menuIconSrc" alt="" />
      </button>
    </div>
    <transition name="header-search-fade">
      <div v-if="searchVisible" class="site-header__search-panel">
        <button class="site-header__search-submit" type="button" aria-label="搜索" @click="submitSearch">
          <img class="site-header__search-icon" referrerpolicy="no-referrer" :src="menuIconSrc" alt="" />
        </button>
        <input ref="searchInput" v-model="searchKeyword" class="site-header__search-input" type="text" placeholder="请输入关键词" @keyup.enter="submitSearch" />
        <button class="site-header__search-close" type="button" aria-label="关闭搜索" @click="toggleSearch">×</button>
      </div>
    </transition>
    <div class="site-header__underline" :class="`site-header__underline--${activeMenu}`"></div>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      searchVisible: false,
      searchKeyword: ''
    };
  },
  computed: {
    activeMenu() {
      const path = this.$route && this.$route.path ? this.$route.path : '/';
      if (path.startsWith('/research')) return 'research';
      if (path.startsWith('/news')) return 'news';
      return 'home';
    },
    logoSrc() {
      return require('@/views/news/assets/img/SketchPng81934d078e0861ba65475c5a2827058029530b1e82fb695468c7b3cf793d1391.png');
    },
    menuIconSrc() {
      return require('@/views/news/assets/img/SketchPng43491eb8ee751537b77323fae58f8e2fe71e206e366e10bdea72570d68af46aa.png');
    }
  },
  methods: {
    toggleSearch() {
      this.searchVisible = !this.searchVisible;
      if (this.searchVisible) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      }
    },
    submitSearch() {
      const keyword = this.searchKeyword.trim();
      if (!keyword) return;
      this.$router.push({
        path: '/news',
        query: { keyword }
      });
      this.searchVisible = false;
    }
  }
};
</script>

<style scoped>
.site-header {
  position: relative;
  background-color: rgba(255, 255, 255, 1);
  height: 2.72rem;
  width: 51.2rem;
}

.site-header__row {
  width: 45.067rem;
  height: 1.44rem;
  margin: 0.64rem 0 0 2.134rem;
  display: flex;
  align-items: center;
}

.site-header__logo {
  width: 4.854rem;
  height: 1.44rem;
}

.site-header__link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.8rem;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 0.533rem;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 0.8rem;
}

.site-header__nav {
  display: flex;
  align-items: center;
  margin: 0.454rem 0 0 22.267rem;
}

.site-header__link + .site-header__link {
  margin-left: 2.96rem;
}

.site-header__link--home {
  width: 1.067rem;
}

.site-header__link--research,
.site-header__link--news {
  width: 2.134rem;
}

.site-header__link--active {
  color: rgba(0, 71, 193, 1);
}

.site-header__search-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.96rem;
  height: 0.96rem;
  margin: 0.454rem 0 0 4.027rem;
  border-radius: 50%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.site-header__search-trigger--active {
  background-color: rgba(2, 100, 253, 0.12);
}

.site-header__icon {
  width: 0.56rem;
  height: 0.56rem;
  margin: 0;
}

.site-header__search-panel {
  position: absolute;
  right: 2.134rem;
  top: 2.134rem;
  width: 12rem;
  height: 1.44rem;
  border: 1px solid rgba(2, 100, 253, 0.24);
  border-radius: 0.72rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.16rem 0.64rem rgba(2, 100, 253, 0.12);
  display: flex;
  align-items: center;
  z-index: 20;
}

.site-header__search-icon {
  width: 0.48rem;
  height: 0.48rem;
  opacity: 0.7;
}

.site-header__search-submit {
  width: 1.2rem;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.site-header__search-input {
  flex: 1;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0 0.267rem;
  font-size: 0.48rem;
  font-family: SourceHanSansCN-Regular;
}

.site-header__search-input:focus {
  outline: none;
}

.site-header__search-close {
  width: 0.8rem;
  height: 0.8rem;
  margin-right: 0.267rem;
  border: none;
  border-radius: 50%;
  background: rgba(2, 100, 253, 0.1);
  color: rgba(0, 71, 193, 1);
  font-size: 0.64rem;
  line-height: 0.8rem;
  padding: 0;
  cursor: pointer;
}

.header-search-fade-enter-active,
.header-search-fade-leave-active {
  transition: all 0.18s ease;
}

.header-search-fade-enter,
.header-search-fade-leave-to {
  opacity: 0;
  transform: translateY(-0.133rem);
}

.site-header__underline {
  width: 2.56rem;
  height: 0.16rem;
  margin-top: 0.48rem;
  background-color: rgba(0, 71, 193, 1);
}

.site-header__underline--home {
  margin-left: 28.509rem;
}

.site-header__underline--research {
  margin-left: 33.069rem;
}

.site-header__underline--news {
  margin-left: 38.163rem;
}
</style>
